import jsPDF from 'jspdf';
import 'jspdf-autotable';

// Helper to format date
const formatDate = () => {
    const d = new Date();
    return d.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
};

/**
 * Generates a PDF report with a consistent design
 * @param {string} title - The title of the report
 * @param {string} subtitle - Optional subtitle or description
 * @param {Array} columns - Array of column headers
 * @param {Array} data - Array of arrays containing the data rows
 * @param {string} fileName - The name of the file to save
 * @param {string} brandName - The name of the app (e.g., "Nujum Admin")
 * @param {string} generatedBy - Name of the person generating the report
 */
export const generatePDF = (title, subtitle, columns, data, fileName, brandName = "NUJUM DASHBOARD", generatedBy = "") => {
    const doc = new jsPDF({ orientation: 'landscape' });
    const pageWidth = doc.internal.pageSize.width;

    // --- Header ---
    // Brand Color Line
    doc.setDrawColor(255, 193, 7); // Brand Golden
    doc.setLineWidth(2);
    doc.line(14, 15, pageWidth - 14, 15);

    // Title
    doc.setFontSize(22);
    doc.setTextColor(28, 28, 30); // Brand Dark
    doc.text(brandName.toUpperCase(), 14, 25);

    doc.setFontSize(10);
    doc.setTextColor(100);
    doc.text("System Report", 14, 30);

    // Report Title
    doc.setFontSize(16);
    doc.setTextColor(0);
    doc.text(title, pageWidth - 14, 25, { align: 'right' });

    // Metadata
    doc.setFontSize(10);
    doc.setTextColor(100);

    let yPos = 32;
    doc.text(`Generated: ${formatDate()}`, pageWidth - 14, yPos, { align: 'right' });
    yPos += 5;

    if (generatedBy) {
        doc.text(`Generated by: ${generatedBy}`, pageWidth - 14, yPos, { align: 'right' });
        yPos += 5;
    }

    if (subtitle) {
        doc.text(subtitle, pageWidth - 14, yPos, { align: 'right' });
    }

    // --- Table ---
    doc.autoTable({
        head: [columns],
        body: data,
        startY: yPos + 8,
        theme: 'grid',
        headStyles: {
            fillColor: [28, 28, 30], // Brand Dark
            textColor: [255, 255, 255],
            fontSize: 10,
            fontStyle: 'bold',
            halign: 'center'
        },
        bodyStyles: {
            fontSize: 8, // Smaller font for more columns
            textColor: [50, 50, 50],
            cellPadding: 2
        },
        alternateRowStyles: {
            fillColor: [249, 250, 251]
        },
        margin: { top: 45 },
        didDrawPage: function (data) {
            // Footer
            const pageCount = doc.internal.getNumberOfPages();
            doc.setFontSize(8);
            doc.setTextColor(150);
            doc.text(
                `Page ${pageCount}`,
                pageWidth / 2,
                doc.internal.pageSize.height - 10,
                { align: 'center' }
            );
        }
    });

    // Save
    doc.save(fileName);
};
